export const DELETE_USER_REQUEST = "DELETE_USER_REDUCER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_REDUCER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_REDUCER_FAIL";
